import React, {useCallback} from 'react'
import {useLocation} from 'react-router'
import {Get, Post} from '../../../../../setup'
import {useMailing} from '../../../../../app/@types'
import {PATH_MAILING} from '../../../../../app/routing/paths'
import {ActionsButton} from './ActionsButtons'

const CANCEL = process.env.REACT_APP_MAILING_CANCEL_A_CAMPAIGN || "v2/campaigns-annuler"
const DUPLICATE = process.env.REACT_APP_MAILING_DUPLICATE_CAMPAIGN || 'v2/campaigns-double'
const ARCHIVER = process.env.REACT_APP_MAILING_ARCHIVER_CAMPAIGN || 'v2/campaigns-archiver'


const ActionButtonsColumnWebForm = ({id}: {id: number}) => {

  const {pathname} = useLocation()
  const {triggerReload} = useMailing()

  const isOnFavorites = pathname === '/mailing/campagnes/favoris'
  const isOnDrafts = pathname === '/mailing/campagnes/brouillons'
  const isOnScheduled = pathname === '/mailing/campagnes/programmees'
  const isOnSent = pathname === '/mailing/campagnes/envoyees'

  const showPreviewButton = !isOnFavorites
  const showEditButton = isOnDrafts || isOnScheduled || isOnSent
  const showStatisticsButton = isOnSent
  const showDuplicateButton = isOnDrafts || isOnScheduled || isOnSent
  const showArchiveButton = isOnDrafts || isOnScheduled || isOnSent
  const showCancelButton = isOnScheduled

  const handleAction = useCallback(
    async (endpoint: string) => {

      const ids = {campaigns_id: [id]}
      await Post<any>(endpoint, ids)
      triggerReload()
    },
    [id, triggerReload],
  )

  const cancelAction = useCallback(
    async () => {
      
      const endpoint = `${CANCEL}/${id}`
      await Get<any>({endpoint})
      triggerReload()
    },
    [id, triggerReload],
  )
  
  return (
    <div className="d-flex justify-content-start">

      {showPreviewButton && (
        <ActionsButton tooltip="Aperçu" to={`${PATH_MAILING.campaign.show}/${id}`} iconPath="" iconClass="bi bi-eye-fill fs-3 text-success"
                      className="btn btn-sm btn-icon btn-active-light-success me-1"
        />
      )}

      {showEditButton && (
        <ActionsButton tooltip="Éditer" to={`${PATH_MAILING.campaign.edit}/${id}`} iconPath="/media/icons/duotune/art/art005.svg"
                      iconClass="svg-icon-2 svg-icon-primary"
                      className="btn btn-sm btn-icon btn-active-light-primary me-1"
        />
      )}

      {showStatisticsButton && (
        <ActionsButton tooltip="Statistiques" to={`${PATH_MAILING.campaign.statistics}/${id}`} iconPath="/media/icons/duotune/graphs/gra010.svg"
                      iconClass="svg-icon-2 svg-icon-primary"
                      className="btn btn-sm btn-icon btn-active-light-primary me-1"
        />
      )}

      {showDuplicateButton && (
        <ActionsButton tooltip="Dupliquer" iconPath="/media/icons/duotune/general/gen028.svg"
                      iconClass="svg-icon-2 svg-icon-warning"
                      className="btn btn-sm btn-icon btn-active-light-warning" onClick={() => handleAction(DUPLICATE)}
        />
      )}

      {showArchiveButton && (
        <ActionsButton tooltip="Archiver" iconPath="/media/icons/duotune/files/fil017.svg"
                      iconClass="svg-icon-2 svg-icon-info" className="btn btn-sm btn-icon btn-active-light-info"
                      onClick={() => handleAction(ARCHIVER)}
        />
      )}

      {showCancelButton && (
        <ActionsButton tooltip="Annuler" iconPath="/media/icons/duotune/abstract/abs012.svg"
                      iconClass="svg-icon-2 svg-icon-danger"
                      className="btn btn-sm btn-icon btn-active-light-danger mx-3" onClick={() => cancelAction}
        />
      )}
    </div>
  )
}

export {ActionButtonsColumnWebForm}